import { render } from "./Werkzaamheden.vue?vue&type=template&id=579eab6c&scoped=true&ts=true"
import script from "./Werkzaamheden.vue?vue&type=script&lang=ts"
export * from "./Werkzaamheden.vue?vue&type=script&lang=ts"

import "./Werkzaamheden.vue?vue&type=style&index=0&id=579eab6c&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579eab6c"]])

export default __exports__